import { ApiEndpointClient } from './resource-client';
const APPRAISING_ENTITIES_API_PREFIX = 'appraising-entities-api/v1';
export class AppraisingEntitiesClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, APPRAISING_ENTITIES_API_PREFIX);
        this.http = http;
    }
    getAppraisingEntities = async () => {
        return this.get('/entities/');
    };
}
